import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const theme: ThemeApp['appComponents']['sessionLogs'] = {
  components: {
    sessionLogsHeader: {
      sessionLogsHeader: {
        headerIconButton: {
          color: themeUi.semantic.color.text.neutral700
        }
      },

      components: {
        clearButton: {
          clearButton: {
            color: themeUi.semantic.color.text.neutral700
          }
        }
      }
    }
  }
};

export default theme;
